import { z } from "zod";
import { TaskType } from "@remi/enums/task-type";

export const SubmitRoofItelTaskAttemptSchema = z.object({
  type: z.literal(TaskType.SUBMIT_ROOF_ITEL),
});
